// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__TPuVP","header":"Messages_header__1X-kM"};